var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84025 25.4264C4.56787 24.9951 4.43168 24.7794 4.35545 24.4468C4.29818 24.197 4.29818 23.803 4.35545 23.5532C4.43168 23.2206 4.56787 23.0049 4.84024 22.5736C7.09106 19.0097 13.7908 10 24.0008 10C34.2108 10 40.9106 19.0097 43.1614 22.5736C43.4337 23.0049 43.5699 23.2206 43.6462 23.5532C43.7034 23.803 43.7034 24.197 43.6462 24.4468C43.5699 24.7794 43.4337 24.9951 43.1614 25.4264C40.9106 28.9903 34.2108 38 24.0008 38C13.7908 38 7.09106 28.9903 4.84025 25.4264Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0008 30C27.3145 30 30.0008 27.3137 30.0008 24C30.0008 20.6863 27.3145 18 24.0008 18C20.6871 18 18.0008 20.6863 18.0008 24C18.0008 27.3137 20.6871 30 24.0008 30Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d5bb411c85fcb22d58eeeeaa2193eb7f.svg";
export { ForwardRef as ReactComponent };